import { Clock, Sparkles, Star } from "lucide-react";

import { cn } from "@/utils/cn";

export type CollectionId = "all" | "favorites" | "recents";

type Props = {
  value: CollectionId;
  onChange: (v: CollectionId) => void;
  counts: Record<CollectionId, number>;
};

const TABS: Array<{ id: CollectionId; label: string; icon: React.ReactNode }> = [
  { id: "all", label: "All apps", icon: <Sparkles className="h-3.5 w-3.5" /> },
  { id: "favorites", label: "Favorites", icon: <Star className="h-3.5 w-3.5" /> },
  { id: "recents", label: "Recent", icon: <Clock className="h-3.5 w-3.5" /> },
];

export function CollectionTabs({ value, onChange, counts }: Props) {
  return (
    <div role="tablist" className="flex gap-1 border-b border-slate-200">
      {TABS.map((t) => (
        <button
          key={t.id}
          role="tab"
          aria-selected={value === t.id}
          onClick={() => onChange(t.id)}
          className={cn(
            "-mb-px flex items-center gap-2 border-b-2 px-3 py-2 text-sm font-medium transition",
            value === t.id
              ? "border-brand-500 text-brand-700"
              : "border-transparent text-slate-500 hover:text-slate-700",
          )}
        >
          {t.icon}
          {t.label}
          <span
            className={cn(
              "rounded-full px-1.5 text-[10px] font-semibold",
              value === t.id
                ? "bg-brand-100 text-brand-700"
                : "bg-slate-100 text-slate-500",
            )}
          >
            {counts[t.id]}
          </span>
        </button>
      ))}
    </div>
  );
}
